import React from 'react';
import { useIntl } from 'react-intl';
import { get, orderBy } from 'lodash';
import { Insurance } from '@lib/resources/types';
import { Divider, WithStyles, withStyles } from '@material-ui/core';

import { Typography } from 'components/v2';
import InsuranceCaptureItem from './components/InsuranceCaptureItem';

import styles from './InsuranceCapture.styles';
import messages from './InsuranceCapture.messages';

interface InsuranceCaptureProps extends WithStyles<typeof styles> {
  question: unknown;
}

function InsuranceCapture({ question, classes }: InsuranceCaptureProps) {
  const { formatMessage } = useIntl();
  const shouldShowEligibility = get(question, 'properties.runInsuranceEligibility', false);

  const insurances = get(question, 'insurances', []) as Insurance[];

  const sortedInsurancesToShow = orderBy(insurances, ['primary', 'verification'], ['desc', 'desc']);

  return (
    <div className={classes.root}>
      <Typography variant="bW600F16">{formatMessage(messages.insuranceTitle)}</Typography>
      {sortedInsurancesToShow.map((insuranceItem, index) => (
        <React.Fragment key={insuranceItem._id}>
          <InsuranceCaptureItem item={insuranceItem} shouldShowEligibility={shouldShowEligibility} />
          {index !== sortedInsurancesToShow.length - 1 ? <Divider /> : null}
        </React.Fragment>
      ))}
    </div>
  );
}

export default withStyles(styles)(InsuranceCapture);
